/* eslint-disable consistent-return */
import React, { useEffect, useRef, useState } from 'react';
import { Backdrop, Box } from '@mui/material';
import UPButton from 'components/button';
import {
  ModalCloseIcon,
  ModalContainer,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  ModalWrapper,
} from 'modules/blogs/styles';
import { useTranslation } from 'react-i18next';
import theme from 'theme';
import {
  GENERAL__AGREE_AND_CONFIRM,
  GENERAL__CLOSE,
  ONBOARDING__COLLABORATION_AGREEMENT,
} from 'translations/constants';
import { ReactComponent as CloseIcon } from '../../../../assets/icons/Close.svg';
import CollaborationAgreementTemplate from './CollaborationAgreementTemplate';

const CollaborationAgreementModal: React.FC<{ onClose: () => void; onApprove: () => void }> = ({
  onClose,
  onApprove,
}) => {
  const [t] = useTranslation();
  const [isScrolledToBottom, setIsScrolledToBottom] = useState(false);
  const contentRef = useRef(null);
  const [isContentRefVisible, setIsContentRefVisible] = useState(false);

  useEffect(() => {
    if (!isContentRefVisible) return;

    const container = contentRef.current;
    if (!container) return;

    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = container;
      setIsScrolledToBottom(scrollTop + clientHeight >= scrollHeight - 5);
    };

    container.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => {
      container.removeEventListener('scroll', handleScroll);
    };
  }, [isContentRefVisible]);

  return (
    <Backdrop open sx={{ zIndex: appTheme => appTheme.zIndex.drawer + 1 }}>
      <ModalWrapper open disableAutoFocus disableEnforceFocus>
        <ModalContainer>
          <ModalHeader>
            <ModalTitle>{t(ONBOARDING__COLLABORATION_AGREEMENT)}</ModalTitle>
            <ModalCloseIcon onClick={onClose}>
              <CloseIcon fill={theme.palette.secondary.contrastText} />
            </ModalCloseIcon>
          </ModalHeader>
          <Box
            ref={el => {
              contentRef.current = el;
              setIsContentRefVisible(!!el);
            }}
            sx={{
              height: '500px',
              overflowY: 'auto',
              padding: `${theme.spacing(1)} ${theme.spacing(4)}`,
            }}
          >
            <CollaborationAgreementTemplate />
          </Box>
          <ModalFooter>
            <UPButton onClick={onClose} text={t(GENERAL__CLOSE)} outlined />
            <UPButton onClick={onApprove} text={t(GENERAL__AGREE_AND_CONFIRM)} disabled={!isScrolledToBottom} />
          </ModalFooter>
        </ModalContainer>
      </ModalWrapper>
    </Backdrop>
  );
};

export default CollaborationAgreementModal;
